import { BaseUseCase } from "../../../useCases/UseCaseBase";
class MFSIPStartDateUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getMfSipStartDate(req);
    }
}
export default MFSIPStartDateUseCase;
